import React, {useState} from 'react';


const SeatManagement = () => {
    const [maxOccupancy, setMaxOccupancy] = useState(70);
    const [holdTime, setHoldTime] = useState(10);
    const [reservationTime, setReservationTime] = useState(10);
    const [requiresCreditCard, setRequiresCreditCard] = useState(false);
    const [noShowCharge, setNoShowCharge] = useState(0);
    const [tagText, setTagText] = useState('');
    const [tags, setTags] = useState([]);

    const handleMaxOccupancyChange = (e) => {
        const value = Math.max(1, Math.min(100, Number(e.target.value)));
        setMaxOccupancy(value);
    };

    const handleHoldTimeChange = (e) => {
        const value = Math.max(1, Math.min(30, Number(e.target.value)));
        setHoldTime(value);
    };

    const handleReservationTimeChange = (e) => {
        const value = Math.max(0, Math.min(100, Number(e.target.value)));
        setReservationTime(value);
    };

    const handleNoShowChargeChange = (e) => {
        const value = Math.max(0, Math.min(100, Number(e.target.value)));
        setNoShowCharge(value);
    };

    const handleAddTag = () => {
        if (tagText.trim() !== '') {
            setTags([...tags, tagText]);
            setTagText('');
        }
    };

    const handleRemoveTag = (index) => {
        setTags(tags.filter((_, i) => i !== index));
    };

    return (
        <div>
            <h3 className='seat-title'>ניהול הושבה</h3>
            <div className='input-container max-occupancy'>
                <label>
                    אחוז תפוסה מקסימלי:
                    <input
                        type='number'
                        value={maxOccupancy}
                        onChange={handleMaxOccupancyChange}
                        min='1'
                        max='100'
                        className='max-occupancy-input'
                    />
                </label>
            </div>
            <div className='input-container hold-time'>
                <label>
                    סמן שולחן כתפוס מרגע תחילת הזמנה ל:
                    <input
                        type='number'
                        value={holdTime}
                        onChange={handleHoldTimeChange}
                        min='1'
                        max='30'
                        className='hold-time-input'
                    /> דקות
                </label>
            </div>
            <div className='input-container reservation-time'>
                <label>
                    שמירת שולחן מוזמן:
                    <input
                        type='number'
                        value={reservationTime}
                        onChange={handleReservationTimeChange}
                        step='5'
                        min='0'
                        max='100'
                        className='reservation-time-input'
                    /> דקות
                </label>
            </div>
            <h3 className='seat-title'>חיובים ופקדונות</h3>
            <div className='input-container credit-card-required'>
                <label>
                    <input
                        type='checkbox'
                        checked={requiresCreditCard}
                        onChange={(e) => setRequiresCreditCard(e.target.checked)}
                        className='credit-card-checkbox'
                    />
                    דרוש כרטיס אשראי לפקדון על מנת לבצע הזמנה
                </label>
            </div>
            <div className='input-container no-show-charge'>
                <label>
                    חיוב אוטומטי של
                    <input
                        type='number'
                        value={noShowCharge}
                        onChange={handleNoShowChargeChange}
                        min='0'
                        max='100'
                        className='no-show-charge-input'
                    />
                    % מסך ההזמנה במידה של אי הגעה ללא ביטול
                </label>
            </div>
            <h3 className='seat-title'>ניהול תגיות</h3>

            <div className='input-container tag-input'>
                <label>
                    הוסף תגית:
                    <input
                        type='text'
                        value={tagText}
                        onChange={(e) => setTagText(e.target.value)}
                        className='tag-input-field'
                    />
                    <button type='button' className='add-time-range-button' onClick={handleAddTag}>+</button>
                </label>
            </div>
            <div className='tag-container'>
                {tags.map((tag, index) => (
                    <div key={index} className='tag'>
                        {tag}
                        <button type='button' className='remove-tag-button' onClick={() => handleRemoveTag(index)}>x
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SeatManagement;
